<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn color="primary" @click="$emit('selectall')">
        Selecionar todos
      </v-btn>
      <v-spacer/>
      <px-search-text label="Busque por um estado" v-model="filters.searchText"
                      style="max-width: 400px"
                      :on-search="onUpdateFilters"/>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    values: Array,
    maxSelect: {
      type: Number,
    },
  },
  data() {
    return {
      statusOptions: [],
      filters: {
        searchText: null,
        includeProdutos: true,
      },
    };
  },
  methods: {
    onUpdateFilters() {
      this.$emit('update', this.filters);
    },
    onClickClose() {
      this.$emit('reset');
    },
  },
};
</script>
